module.exports = __webpack_public_path__ + "static/media/masaze.855b8ee0.svg";